// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"clientReviewPage_loader_wrapper__fTT1+"};